export function tenureLabel(createdAt) {
	if (!createdAt) return null;
	const days = Math.max(0, Math.floor((Date.now() - new Date(createdAt).getTime()) / 86400000));
	if (days < 30) return `Client de ${days} ${days === 1 ? "zi" : "zile"}`;
	const months = Math.floor(days / 30);
	if (months < 12) return `Client de ${months} ${months === 1 ? "lună" : "luni"}`;
	const years = Math.floor(months / 12);
	return `Client de ${years} ${years === 1 ? "an" : "ani"}`;
}
